<template>
  <div class="vlt-header-r-sec ">
    <div class="user-info" v-if="subscriberid">
       <div
        class="hamb-btn vlt-dark">
        <button
          type="button"
          class="btn-hamb lite"
          @click="() => toggleMenuCB(true)"
          aria-label="menu-hamb-btn"
          aria-labelledby="menu"
          role="none">
            <img src="@/assets/icons/Ic_sidemenu.svg" alt="hamburger icon">
        </button>
      </div>
      <div class="vlt-header-notif">
          <button
            type="button"
            class="vlt-btn-ico lite"
            :class="notifBtnClass"
            @click="toggleNotificationPopup"
            style="cursor: pointer;">
            <img
              src="@/assets/icons/notification.svg"
              alt="notif-btn-ico">
              <span v-if="newMessage" class="badge"></span>
          </button>
      </div>
      <!-- Profile Area -->
      <div  class="vlt-header-prof">
        <div
          class="vlt-hprof"
          @click="toggleProfileMenu"
          style="cursor: pointer;">
            <img
              v-if="picture"
              :src="picture"
              alt="vlt-prof"
              class="img-responsive" style="float: left;" />
            <!-- <div class="profile-default" v-else>
              <p>G</p>
            </div> -->
            <img v-else
              :src="defaultPicture"
              alt="vlt-prof"
              class="img-responsive" style="float: left;"/>
          <p v-if="AppUser" class="subscribername">{{AppUser.subscribername}}</p>
          <img id="profilearrow" :src="iconArrowDown" alt="down arrow"/>          
        </div>

        <ProfileMenu
          v-show="showProfileMenu"
          :size="`260px`"
          class="profile-menu"
          :closePopup="toggleProfileMenu"
          :showLoaderCB="showLoaderCB"/>
      </div>
      <Menu
        v-show="showMenu"
        :categories="menucategories"
        :closeMenu="(state) => toggleMenuCB(state)" />
      
    </div>
    <div class="user-info" v-else>
      <div class="row">
        <div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <div @click="() => toggleSignupPopup(true)"
            class="signup-button"
            v-if="showSignup">
            <h5>{{signup}}</h5>          
          </div>
        </div>
        <div class="col-xlg-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <div @click="() => toggleLoginPopup(true)"
            class="login-signup-button"
            v-if="showLogin">
            <h5>{{signin}}</h5>          
          </div>
        </div>
      </div>
    </div>
    <transition name="popup-animate">
      <PopupLogin
        v-if="showPopuplogin"
        :previousActionData="loginPreviousActionData"
        :closePopupCB="() => toggleLoginPopup(false)" />
        <PopupSignup
        v-if="showPopupsignup"
        :previousActionData="signupPreviousActionData"
        :closePopupCB="() => toggleSignupPopup(false)" />
         <PopupResetPassword
        v-if="showPopupResetPassword"
        :closePopupCB="() => toggleResetPasswordPopup(false)"
        :togglePopupMessage="(state, data) => togglePopupMessage(state, data)" />
        <PopupPayment
        v-if="showPaymentPopup"
        :paymentData="paymentData"
        :closePopupCB="() => togglePaymentPopup(false)" />
        <PopupEditProfile
        v-if="showPopupEditProfile"
        :closePopupCB="() => toggleEditProfilePopup(false)" />
        <PopupNotification
        v-if="showNotificationPopup"
        :closePopupCB="() => toggleNotificationPopup(false)" />
        <PopupAbout
        v-if="showAboutPopup"
        :closePopupCB="() => toggleAboutPopup(false)" />
        <PopupShared
        v-if="showSharedPopup"
        :contentId="sharedContentId"
        :closePopupCB="() => toggleSharePopup(false)" />
        <PopupChangePassword
        v-if="showChangePasswordPopup"
        :closePopupCB="() => toggleChangePasswordPopup(false)" />
         <PopupContactSupport
        v-if="showContactSupportPopup"
        :closePopup="() => toggleContactSupportPopup(false)" />
        <PopupMessage
        v-if="showPopupMessage"
        :popupData="popupMessageData"
        :closePopupCB="() => togglePopupMessage(false)" />
    </transition>
  </div>
</template>

<script>
import ProfileMenu from './ProfileMenu.vue';
import User from '@/mixins/User';
import { mapGetters } from 'vuex';
import { EventBus } from '@/main';
import App from '@/mixins/App';


export default {
  name: 'HeaderRightRegistered',
  data () {
    return {
      signup:'Sign up',
      signin:'Sign in',
      showSignup: true,
      showLogin: true,
      notifBtnClass: '',
      showNotificationBox: false,
      showProfileMenu: false,
      showLoader: false,
      showPopuplogin: false,
      showPopupsignup: false,
      showPopupResetPassword: false,
      showPaymentPopup: false,
      paymentData: null,
      showPopupEditProfile: false,
      defaultPicture: require('@/assets/icons/iconuser.png'),
      iconArrowDown: require('@/assets/icons/sort-down.png'),
      iconArrowUp: require('@/assets/icons/sort-up.png'),
      notificationNo: '',
      showNotificationPopup: false,
      showAboutPopup: false,
      //
      showSharedPopup: false,
      sharedContentId: null,
      //
      showChangePasswordPopup: false,
      //
      loginPreviousActionData: null,
      signupPreviousActionData: null,
      //
      menucategories: [],
      showMenu: false,
      //
      showContactSupportPopup: false,
      //
      showPopupMessage: false,
      popupMessageData: null
    }
  },
  computed: {
    ...mapGetters([
      'subscriberid',
      'picture',
      'newMessage',
      'notificationCount',
      'AppUser'
    ]),
  },
  components: {
    ProfileMenu,
    PopupLogin : () => import("@/components/Popups/Login.vue"),
    PopupSignup : () => import("@/components/Popups/SignUp.vue"),
    PopupResetPassword : () => import("@/components/Popups/ResetPassword.vue"),
    PopupPayment : () => import("@/components/Popups/Payment.vue"),
    PopupEditProfile : () => import("@/components/Popups/EditProfile.vue"),
    PopupNotification : () => import("@/components/Popups/Notification.vue"),
    PopupAbout : () => import("@/components/Popups/About.vue"),
    PopupShared : () => import("@/components/Popups/sharedContent.vue"),
    PopupChangePassword : () => import("@/components/Popups/ChangePassword.vue"),
    PopupContactSupport : () => import("@/components/Popups/ContactSupport.vue"),
    Menu : () => import("@/components/Header/Menu/Menu.vue"),
    PopupMessage : () => import('@/components/Popups/Message.vue')

  },
  created () {
    this.assertTemplate();
  },
  mounted () {
    //open Login popup
    EventBus.$on('LoginPopup', (data)=> {
      if (data) {
        this.loginPreviousActionData = data
      } else {
        this.loginPreviousActionData = null
      }
      this.closeAllPopups()
      this.toggleLoginPopup(true)
    });
    //open Signup popup
    EventBus.$on('SignPopup', (data)=> {
      if (data) {
        this.signupPreviousActionData = data
      } else {
        this.signupPreviousActionData = null
      }
      this.closeAllPopups()
      this.toggleSignupPopup(true)
    });
    //open ResetPassword popup
    EventBus.$on('ResetPasswordPopup', (state)=> {
      this.closeAllPopups()
      this.toggleResetPasswordPopup(state)
    });
    // open payment popup
    EventBus.$on('PaymentPopup', (data)=> {
      this.closeAllPopups()
      this.paymentData = data;
      this.togglePaymentPopup(true)
    });
    //open EditProfile popup
    EventBus.$on('EditProfile', ()=> {
      this.closeAllPopups()
      this.toggleEditProfilePopup(true)
    });
     //open About popup
    EventBus.$on('AboutPopup', ()=> {
      this.closeAllPopups()
      this.toggleAboutPopup(true)
    });
    // open shared popup
    EventBus.$on('sharedPopup', (id)=> {
      this.closeAllPopups()
      if (id) {
        this.sharedContentId = id;
        this.toggleSharePopup(true)
      }
    });
    //open ChnagePassword popup
    EventBus.$on('ChangePasswordPopup', ()=> {
      this.closeAllPopups()
      // this.showChangePasswordPopup = true;
      this.toggleChangePasswordPopup(true)
    });
    //open Notification popup
    EventBus.$on('NotificationPopup', ()=> {
      this.closeAllPopups()
      this.toggleNotificationPopup(true)
    });
    //
    //open Contact popup
    EventBus.$on('ContactPopup', ()=> {
      this.closeAllPopups()
      this.toggleContactSupportPopup(true)
    });
     //Common Error popup
    EventBus.$on('CommonErrorPopup', (data)=> {
      this.closeAllPopups()
      this.popupMessageData = data;
      this.togglePopupMessage(true)
    });
    // deep linking
    let currentroute =  this.$router.currentRoute
    // console.log('currentroute', currentroute)
    if (currentroute && currentroute.params) {
      // share content
      if (currentroute.params && (currentroute.params.link == "content") && currentroute.query.contentid && (currentroute.query.coupon == undefined))  {
        window.history.pushState({}, document.title, "/");
        //
        this.sharedContentId =  currentroute.query.contentid
        this.toggleSharePopup(true)
      }
      // payment content
      if (currentroute.params && (currentroute.params.link == "content") && currentroute.query.contentid && (currentroute.query.coupon !== undefined))  {
        window.history.pushState({}, document.title, "/");
        //
        let data = {
          contentid: currentroute.query.contentid,
          coupon: currentroute.query.coupon
        }
        if (this.subscriberid) {
          EventBus.$emit('PaymentPopup',data)
        } else {
          data.popup = 'PaymentPopup'
          EventBus.$emit('LoginPopup', data)
        }        
      }
      // registration or signup      
      if (currentroute.params && (currentroute.params.link == "registration"))  {
        window.history.pushState({}, document.title, "/");
        //
        EventBus.$emit('SignPopup')
      }
    }
  },
  methods: {
    togglePopupMessage (state) {
      this.showPopupMessage = state
    },
    toggleMenuCB (state) {
      this.showMenu = state;
      this.togglePageSticky(state);
    },
    toggleContactSupportPopup (state) {
      this.showContactSupportPopup = state;
    },
    closeAllPopups () {
      this.showSharedPopup = false;
      this.showAboutPopup = false;
      this.showNotificationPopup = false;
      this.showPopupEditProfile = false;
      this.showPopupsignup = false;
      this.showPopuplogin = false;
      this.showPopupResetPassword = false;
      this.showChangePasswordPopup = false;
      this.showContactSupportPopup = false;
    },
    toggleChangePasswordPopup (state) {
      this.showChangePasswordPopup = state;
    },
    toggleSharePopup (state) {
      this.showSharedPopup = state;
      if (!state) {
        this.sharedContentId = null
      }
    },
    toggleAboutPopup (state) {
      this.showAboutPopup = state;
    },
    toggleNotificationPopup (state) {
      this.showNotificationPopup = state;
    },
    toggleEditProfilePopup (state) {
      this.showPopupEditProfile = state;
    },
    togglePaymentPopup (state) {
      this.showPaymentPopup = state;
    },
    toggleResetPasswordPopup (state) {
      if (state){
        this.toggleLoginPopup(false);
      }
      this.showPopupResetPassword = state;
    },
    toggleLoginPopup (state) {
      this.showPopuplogin = state;
      if (!state) {
        this.loginPreviousActionData = null
      }
    },
    toggleSignupPopup (state) {
      this.showPopupsignup = state;
    },
    showLoaderCB (state) {
      this.showLoader = state;
    },
    toggleProfileMenu () {
      let elment = document.getElementById("profilearrow")
      if (elment) {
        elment.src= this.showProfileMenu ? this.iconArrowDown: this.iconArrowUp
      }
      this.showProfileMenu = !this.showProfileMenu;
    },
    assertTemplate () {
      
    },
    notifBtnClickCB () {
      this.showNotificationBox = !this.showNotificationBox
      // EventBus.$emit('toggleNotificationEvent', true)
      // Toggle the Before Element. The small caret created on .vlt-header-notif button
      this.notifBtnClass = this.showNotificationBox ? 'visible' : ''
    },
    fetchUserDataCB () {
      if (localStorage.getItem('AppUser')) {
        let AppUser = JSON.parse(localStorage.getItem('AppUser'));

        if (AppUser.picture) this.picture = AppUser.picture;
      }
    },
  },
  mixins: [ User, App ]
}
</script>

<style lang="scss" scoped>
@import '~sass/modules/components';
.badge {
  position: absolute;
  top: 8px;
  border-radius: 50%;
  background-color: #FB6126;
  width: 10px;
  height: 10px;
  font-size: 12px;
  font-weight: bold;
  right: -1px;
  border: 1px solid #29487d;
}
.vlt-header-login  {
  width: auto !important;
  display: flex;
  flex-direction: row;
  flex: 1;
}
.vlt-header-notif, .vlt-header-prof {
  float: left;
  margin-left: 10px;
}
.vlt-header-notif {
  margin: 0 10px 0 0;
  button {
    position: relative;
    z-index: 91;
    // padding: 12px 0 0 0;
    img {
      width: 20px;
    }
  }
}
.vlt-btn-ico {
  padding: 5px 0;
  &.visible {
    position: relative;
    &::before {
      position: absolute;
      content: '';
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-bottom: 7px solid $clr-dark-grad-2;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
.vlt-hprof {
  padding: 0;
  img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    vertical-align: middle;
  }
  div {
    text-align: center;
    float: left;
    color: white;
    background: black;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    vertical-align: middle;
    p {
      padding: 3px;
      font-size: 20px;
    }
  }
}
.login-signup-button{
  padding: 0;
  background: #C6C6C6;
  color: #212121;
  font-family: "ProximanovaBold";
  width: 90px;	
  cursor: pointer;
  text-align: center;
  border-radius: 2px; 
  h5 {
    padding: 1px 8px;
    font-size: 16px;	  
    line-height: 27px;    
    text-transform: uppercase;
  }
   :hover{
    background: #ffffff;
    border-radius: 2px; 
  } 
}
.vl{
    width: 2px;
    margin: 2px 0;
    background: black;
}
i {
  border: solid black;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  margin-left: 15px;
}
.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}
.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}
.vlt-header-prof .profile-menu {
  // top: 60px;
}
.vlt-header-login {
    margin-left: 20px;
    margin-top: 13px;
}
.profile-menu {
  // display: none;
  // z-index: 999;
}
.hover-profile{
  &:hover{
    .profile-menu {
      display: block;
    }
  }
}
#profilearrow{
  width: 18px;
  height: 18px;
  margin-top: 5px;
}
.signup-button{
  background: #4558DD;
  color: #ffffff;	
  font-family: "ProximanovaBold";
  width: 90px;	
  cursor: pointer;
  text-align: center;
  border-radius: 2px; 
  h5 {
    padding: 1px 8px;
    font-size: 16px;  
    line-height: 27px;    
    text-transform: uppercase;
  }
  :hover{
    background: #5668e6;
  }  
}
.subscribername{
  color: #ffffff;	
  font-family: "ProximanovaBold";
  font-size: 16px;
  padding: 5px; 
  float: left; 
  margin-left: 5px; 
}
// 
.hamb-btn {
  padding-top: 5px;
  margin-left: 10px;
  display: none;
  float: right;
  img {
    width: 20px;
    cursor: pointer;
  }
}
//
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .hamb-btn {
    display: block;
  }
  .vlt-header-notif, .vlt-header-prof{
    display: none;
  }
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 768px)
{
  .user-info{
    // display: none;
  }
}
// 4k 
@media screen and (min-width: 1900px) {
  .signup-button, .login-signup-button{
    width: 120px;
    h5 {
      padding: 5px;
      font-size: 20px;  
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/Right/Private.vue